import { default as ReactSelect } from 'react-select'

export const customStyles = {
    menu: (provided, { selectProps: { width } }) => ({
        ...provided,
        width: '100%',
        background: 'var(--chakra-colors-input)',
        borderRadius: 3,
        zIndex: 4
    }),
    control: (base, { isFocused, selectProps: { width, height, error, dirty } }) => ({
        ...base,
        width: width,
        height: height,
        background: 'var(--chakra-colors-input)',
        borderRadius: 5,
        border: isFocused ? '1px solid #3182ce' : error ? '1px solid var(--chakra-colors-service-red)' : dirty ? '1px solid var(--chakra-colors-green-700)' : '1px solid var(--chakra-colors-border)',
        boxShadow: isFocused ? '0 0 0 1px #3182ce' : error ? '0 0 0 1px var(--chakra-colors-service-red)' : dirty ? '0 0 0 1px var(--chakra-colors-green-700)' : 'none',
        '&:hover': {
            border: isFocused ? '1px solid #3182ce' : error ? '1px solid var(--chakra-colors-service-red)' : dirty ? '1px solid var(--chakra-colors-green-700)' : '1px solid var(--chakra-colors-border-hover)',
        }
    }),
    input: (base) => ({
        ...base,
        borderRadius: 0,
        font: 'var(--code-font)',
        color: 'inherit'
    }),
    option: (base, { isFocused }) => ({
        ...base,
        color: 'inherit',
        background: isFocused ? '#AAAAAA' : 'var(--chakra-colors-input)',
        borderRadius: 0,
        font: 'var(--code-font)'
    }),
    singleValue: (base, { selectProps: { isDisabled } }) => ({
        ...base,
        font: 'var(--code-font)',
        color: isDisabled ? 'gray' : 'inherit',
        borderRadius: 0
    }),
    placeholder: (base) => ({
        ...base,
        font: 'var(--code-font)'
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: 'var(--chakra-colors-select-multi-value)',
        width: 'fit-content',
        boxShadow: 'var(--chakra-shadows-md)',
        margin: '4px 8px 4px 0'
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: 'inherit',
    }),
    multiValueRemove: (base) => ({
        ...base,
        ':hover': {
            backgroundColor: 'var(--chakra-colors-select-multi-value-remove)',
            color: 'white',
        },
        paddingLeft: 0,
        paddingRight: 0,
        marginLeft: '2px',
        marginRight: '2px',
        height: '16px',
        width: '16px',
        alignSelf: 'center',
        justifyContent: 'center',
    }),
}

export const Select = (props) => {
    return <ReactSelect styles={customStyles} {...props} />
}
